import { render, staticRenderFns } from "./BlockedItemVariationListItem.vue?vue&type=template&id=267994ba&scoped=true"
import script from "./BlockedItemVariationListItem.vue?vue&type=script&lang=js"
export * from "./BlockedItemVariationListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267994ba",
  null
  
)

export default component.exports